import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const MetricsChart = ({ metrics }) => {
  const data = {
    labels: ['Resolved', 'Unresolved'],
    datasets: [
      {
        data: [
          metrics.resolved_tickets || 0,
          (metrics.total_tickets || 0) - (metrics.resolved_tickets || 0),
        ],
        backgroundColor: ['#4CAF50', '#FF9800'], // Green for resolved, Orange for unresolved
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Disable aspect ratio to allow custom sizing
    plugins: {
      tooltip: {
        enabled: true,
      },
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <div style={{ width: '300px', height: '300px' }}> {/* Set custom dimensions */}
      <Pie data={data} options={options} />
    </div>
  );
};

export default MetricsChart;